import * as types from "../constants/localConstants"

const initialState = {
    minNavigation: false,
    lang: "en-US"
}

export default function LocalReducer(state=initialState, action) {
    switch(action.type) {
        case types.HANDLE_NAVIGATION:
            return {
                ...state,
                minNavigation: action.payload.minNavigation,
                lang: state.lang,
            }
        case types.SET_LANG:
            return {
                ...state,
                minNavigation: state.minNavigation,
                lang: action.payload.lang,
            }
        default:
            return state
    }
}